export default __webpack_public_path__ + "static/media/snowy-owl.bd2198ba.png";